<!--  -->
<template>
  <div class="footer-wrap">
    <div class="friend-link">
      <p v-for="(item, index) in friendLinkList"
         :key="index">
        <a :href="item.link"
           target="_blank"
           :title="item.name">{{ item.name }}</a>
      </p>
    </div>
    <div class="copy-right">
      <p>版权所有：湖南中教国培教育咨询服务有限公司 备案号： <a target="_blank"
           href="https://beian.miit.gov.cn/">湘ICP备2023013497号-1</a></p>
      <p>Copyright © 2017-2023 zjxinketang.org.cn All Rights Reserved. </p>
    </div>
  </div>
</template>

<script>
import { getHomeFriendLink } from '@/api/index'

export default {
  name: 'MyFooter',
  data () {
    return {
      friendLinkList: []
    }
  },
  //生命周期 - 创建完成（访问当前this实例）
  created () {
    this.init()
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted () {

  },
  methods: {
    //初始化接口
    async init () {
      const friendLink = await getHomeFriendLink();
      this.friendLinkList = friendLink.data;
    }
  }
}
</script>
<style scoped lang="scss">
.footer-wrap {
  .friend-link {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 30px;
    margin: 20px 0;
    flex-wrap: wrap;

    p {
      margin-right: 7px;
      font-size: 14px;
      color: #444444;
    }
  }

  .copy-right {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    p,
    a {
      font-size: 12px;
      color: #444444;
    }
  }
}
</style>